.plotPath {
  stroke-width: 2px;
  fill-opacity: 0;
}
